export default __webpack_public_path__ + "static/media/1512.edf67cc3.png";